<div class="fuse-card" style="min-width: 600px" fxLayout="column">
    <div class="p-16" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="h1 pr-16">Roles</div>
    </div>

    <table class="simple">
        <thead>
            <tr>
                <th>Rol</th>
                <th class="text-right">Cliente</th>
                <th class="text-right">Sucursal</th>
                <th class="text-right">Permisos</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let rol of roles">
                <td>
                    <span class="text-bold">{{ rol.nombre }}</span>
                    <br />
                    <small>
                        {{ rol.fechaInicio }}
                    </small>
                </td>

                <td class="text-right">
                    <div *ngIf="rol.id === config.roles.representante.rol">
                        {{ rol.cliente.nombre }} <br />
                        <small>{{ rol.cliente.rut }}</small>
                    </div>
                    <div *ngIf="rol.id === config.roles.encargado.rol">
                        {{ rol.sucursal.cliente.nombre }} <br />
                        <small>{{ rol.sucursal.cliente.rut }}</small>
                    </div>
                </td>
                <td class="text-right">
                    <div *ngIf="rol.id === config.roles.encargado.rol">
                        {{ rol.sucursal.nombre }} <br />
                        <small
                            >{{ rol.sucursal.direccion }},

                            {{ rol.sucursal.comuna.nombre }}</small
                        >
                    </div>
                    <div *ngIf="rol.id !== config.roles.encargado.rol">-</div>
                </td>
                <td class="text-right">
                    <div *ngIf="rol.id === config.roles.encargado.rol">
                        <span class="text-bold"
                            >Cotizar:
                            <span
                                [ngClass]="{
                                    'warn-700-fg': !rol.sucursal.permisos
                                        .puedeCotizar,
                                    'green-700-fg':
                                        rol.sucursal.permisos.puedeCotizar
                                }"
                            >
                                {{
                                    rol.sucursal.permisos.puedeCotizar
                                        ? "Si"
                                        : "No"
                                }}</span
                            ></span
                        ><br />
                        <span class="text-bold"
                            >Comprar:
                            <span
                                [ngClass]="{
                                    'warn-700-fg': !rol.sucursal.permisos
                                        .puedeComprar,
                                    'green-700-fg':
                                        rol.sucursal.permisos.puedeComprar
                                }"
                            >
                                {{
                                    rol.sucursal.permisos.puedeComprar
                                        ? "Si"
                                        : "No"
                                }}</span
                            > </span
                        ><br />
                        <span class="text-bold"
                            >Recibir:
                            <span
                                [ngClass]="{
                                    'warn-700-fg': !rol.sucursal.permisos
                                        .puedeRecibir,
                                    'green-700-fg':
                                        rol.sucursal.permisos.puedeRecibir
                                }"
                            >
                                {{
                                    rol.sucursal.permisos.puedeRecibir
                                        ? "Si"
                                        : "No"
                                }}
                            </span>
                        </span>
                    </div>
                    <div *ngIf="rol.id === config.roles.supervisor.rol">
                        <span class="text-bold"
                            >Puede crear Supervisor:
                            <span
                                [ngClass]="{
                                    'warn-700-fg': !rol.puedeCrearOtros,
                                    'green-700-fg': rol.puedeCrearOtros
                                }"
                            >
                                {{ rol.puedeCrearOtros ? "Si" : "No" }}
                            </span>
                        </span>
                    </div>
                    <div
                        *ngIf="
                            rol.id !== config.roles.encargado.rol &&
                            rol.id !== config.roles.supervisor.rol
                        "
                    >
                        -
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>
